// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__3CH10","P":"Home_P__1zIkv","Btn":"Home_Btn__OZWg6","Add":"Home_Add__CJGA5","View":"Home_View__5Sca6"};